import { render, staticRenderFns } from "./Tabbaritem.vue?vue&type=template&id=2a79f4a5&scoped=true&"
import script from "./Tabbaritem.vue?vue&type=script&lang=js&"
export * from "./Tabbaritem.vue?vue&type=script&lang=js&"
import style0 from "./Tabbaritem.vue?vue&type=style&index=0&id=2a79f4a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a79f4a5",
  null
  
)

export default component.exports